// extracted by mini-css-extract-plugin
export var chevronIcon = "_4d-2";
export var teamName = "_4d-1";
export var teamSwitcherButton = "_4d-0";